/** @file artClient: the Art screen's server calls over the api client for the session's server URL. */
import { createClient } from '@zilo/pose3d-api/client/createClient';
import { apiAdapter } from '../../store/apiAdapter';
import type { ArtDeps } from './artTypes';

/** `createClient({ url })` narrowed to the per-puppet calls the Art screen makes (dev pages and tests inject their own). */
export function artClient(url: string): ArtDeps {
  const { uploadImage, slotMask, slots } = apiAdapter(createClient({ url })).puppets;
  return { uploadImage, slotMask, slots };
}
